export default __webpack_public_path__ + "static/media/logo_horizontal.e30abaa7.png";